
import React from "react";
import DataTable from "react-data-table-component";
import { SyncLoader } from "react-spinners";
import NoDataPrompt from "../NoDataPrompt/NoDataPrompt";
import "./Table.css";
import { formatAmount } from "../../Helpers/Utils/Common";

export default function Table({
    tableHeaders,
    headerSelector,
    tableData,
    ActionBtn,
    ViewBtn,
    PendingBtn,
    showLoader,
}) {
    function extractRemarks(value) {
        return value.map(data => data.split(":")[1]).join(", ");
    }

    const createColumn = (header, index) => {
        const selector = row => row[headerSelector[index]];

        if (header === "-") {
            return {
                name: "",
                selector,
                button: true,
                cell: ViewBtn,
                width: "7vw",
            };
        }

        if (header === "Name") {
            return {
                name: header,
                cell: row => row.names.split("|").join(", "),
            };
        }

        // if (header === "Amount") {
        //     return {
        //         name: header,
        //         cell: row => row.amount.split("|").join(", "),
        //     };
        // }

        if (header === "ID No.") {
            return {
                name: header,
                cell: row => row.ids.split("|").join(", "),
                width: "13vw",
            };
        }

        if (header === "ACTIONS") {
            return {
                name: header,
                button: true,
                cell: ActionBtn,
                width: "15vw",
            };
        }

        if (header === " ") {
            return {
                name: header,
                button: true,
                cell: PendingBtn,
                width: "10vw",
            };
        }

        if (header.includes("REMARKS")) {
            return {
                name: header,
                selector: row => extractRemarks(selector(row)),
                sortable: true,
                width: "15vw",
            };
        }

        if (header==="AMOUNT") {
            return {
                name: header,
                selector: row => formatAmount(selector(row)),
                sortable: true,
                width: "10vw",
                right: true,
            };
        }

        const widths = {
            "SALES DATE": "35vw",
            "GROSS SALES": "15vw",
            "SALES DISCOUNT": "15vw",
            "SI. FROM": "10vw",
            "SI. TO": "10vw",
            "SI. NO.": "10vw",
            "ID NO.": "10vw",
            "VAT SALES": "15vw",
            "NET VATABLE SALES": "15vw",
            "GROSS VAT SALES": "15vw",
            "NET VAT": "15vw",
            "VAT EXEMPT SALES": "15vw",
            "ZERO-RATED": "15vw",
            "TOTAL SALES": "15vw",
            "TOTAL VAT": "15vw",
            "PWD DISC.": "15vw",
            "SENIOR DISC.": "15vw",
            "OTHER DISC.": "15vw",
            "TOTAL DISC.": "15vw",
            "VAT EXEMPT": "15vw",
            "TOTAL TAX": "15vw",
            "GRAND TOTAL": "15vw",
            "VAT DISCOUNT SALES": "15vw",
            "TYPE": "15vw",
            "SALES": "15vw",
            "FULL NAME": "17vw",
            "ITEM NAME": "17vw",
            "CASHIER": "15vw",
            "DATE": "15vw",
            "DATE ADDED": "15vw",
            "OVER/SHORT": "15vw",
            "DESCRIPTION": "15vw",
            "FILE": "15vw",
            "USERNAME": "25vw",
            "DATE RECEIVED": "17vw",
            "COUNT": "50vw",
            "EXPECTED CNT.": "20vw",
            "PHYSICAL CNT.": "20vw",
            "OVER / SHORT": "20vw",
            "INITIAL DRAWER": "20vw",
            "TOTAL": "20vw",
            "Subtotal": "20vw",
            "Discounted Amount": "20vw",
            "PRICE": "13vw",
            "QUANTITY": "13vw",
            // "AMOUNT": "13vw",
            "TOTAL AMOUNT": "13vw",
            "PERCENTAGE": "13vw",
            "CATEGORIES": "15vw",
            "QTY": "15vw",
            "ROLE": "15vw",
            "ADDED BY": "11vw",
            "FOODPANDA PRICE": "15vw",
            "GRAB PRICE": "15vw",
            "NAME": "20vw",
        };

        const rightAlignedHeaders = [
            "GROSS SALES", "SALES DISCOUNT", "VAT SALES",  "NET VAT", "VAT EXEMPT SALES", "ZERO-RATED", 
            "TOTAL SALES", "TOTAL VAT", "PWD DISC.", "SENIOR DISC.", "OTHER DISC.", 
            "TOTAL DISC.", "VAT EXEMPT", "TOTAL TAX", "GRAND TOTAL", "COUNT", 
            "EXPECTED CNT.", "PHYSICAL CNT.", "OVER / SHORT", "INITIAL DRAWER", 
            "TOTAL", "Subtotal", "Discounted Amount", "PRICE", "QUANTITY", "AMOUNT", 
            "TOTAL AMOUNT", "PERCENTAGE", "GRAB PRICE", "FOODPANDA PRICE", "NET VATABLE SALES", "GROSS VAT SALES", 
        ];

        return {
            name: header,
            selector,
            sortable: true,
            reorder: true,
            width: widths[header],
            right: rightAlignedHeaders.includes(header),
        };
    };

    const columns = tableHeaders.map((header, index) => createColumn(header, index));

    const paginationComponentOptions = {
        rowsPerPageText: "",
        noRowsPerPage: true,
    };

    const customStyles = {
        rows: {
            style: {
                minHeight: "5.2vh",
            },
        },
    };

    return showLoader ? (
        <div className="d-flex justify-content-center my-5">
            <SyncLoader color="var(--tertiary-color)" size={15} />
        </div>
    ) : (
        <DataTable
            pagination
            fixedHeader
            fixedHeaderScrollHeight="50vh"
            columns={columns}
            data={tableData}
            customStyles={customStyles}
            paginationComponentOptions={paginationComponentOptions}
            progressPending={showLoader}
            noDataComponent={<NoDataPrompt />}
        />
    );
}
